export const VERTEX = /* glsl */ `
  varying vec3 vWorldNormal;
  varying vec3 vWorldPosition;
  void main() {
    vec4 worldPos = modelMatrix * vec4(position, 1.0);
    vWorldPosition = worldPos.xyz;
    vWorldNormal = normalize(mat3(modelMatrix) * normal);
    gl_Position = projectionMatrix * viewMatrix * worldPos;
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform vec3 uRimColor;
  uniform vec3 uBaseColor;
  uniform float uRimPower;
  uniform float uRimIntensity;
  varying vec3 vWorldNormal;
  varying vec3 vWorldPosition;
  void main() {
    vec3 viewDir = normalize(cameraPosition - vWorldPosition);
    float fres = pow(1.0 - max(dot(vWorldNormal, viewDir), 0.0), uRimPower);
    gl_FragColor = vec4(uBaseColor + uRimColor * fres * uRimIntensity, 1.0);
  }
`;
